import React from 'react';
import { get, isEqual, cloneDeep, set, forEach, keys, isNil, isEmpty, toNumber, isUndefined, filter } from 'lodash';

// React view component to render
import { memberCheckoutCostInformation as MemberCheckoutCostInformationView } from 'ui/views/widgets/memberCheckoutCostInformation';
import { MemberCheckoutCostInformationService } from 'services/memberCheckoutCostInformation';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { MemberCheckoutCostInformation } from 'ui/containers/MemberCheckoutCostInformation';
 *
 * // render
 * <MemberCheckoutCostInformation propName='propValue'/>
 */
export class MemberCheckoutCostInformation extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );

        // bind
       this._bind();

        // component state
        this.state = {
            isFetching: true,
            networkStatus: undefined,
            componentData: undefined,
            isRemaningBalanceValid: true,
            chargeNowAmount: 0,
            remainingAmount: 0,
        };

        // Member Detail instance
        this.memberCheckoutCostInformationService = new MemberCheckoutCostInformationService();

        // start member detail data fetch
        this.fetchComponentData();
    }

    _bind() {
        this.handleCostSelectionUpdate = this.handleCostSelectionUpdate.bind( this );
        this.handlePayOtherAmountUpdate = this.handlePayOtherAmountUpdate.bind( this );
        this.getCurrentSelection = this.getCurrentSelection.bind( this );
    }

    /**
     * @desc: fetch decription
     */
    async fetchComponentData() {
        log.debug( 'MemberCheckoutCostInformation.fetchComponentData()' );

        // cancel ongoing request
        this.memberCheckoutCostInformationService.cancel();

        // fetch component data
        const { status, data } = await this.memberCheckoutCostInformationService.fetchComponentData( {
            url: this.props.widget.url,
            data: {
                ...get( this.props, 'requestPayload', {} )
            }
        } );

        // check if response status was success
        if( SERVICE_RESPONSE_STATUS.SUCCESS !== status ) {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.FAILURE
            } );
        } else {

            let state = cloneDeep( this.state );
            state.isFetching = false;
            state.networkStatus = SERVICE_RESPONSE_STATUS.SUCCESS;
            state.componentData = data;

            // update the shipping charges if any
            const shippingCharges = get( this.props, 'shippingCharges', null );

            if( ! isEmpty( shippingCharges ) ) {
                set( state.componentData, 'costCalculation.shippingCharges', shippingCharges );
            }

            state = {
                ...state,
                ...this.getCostSelectionValues( { componentData: data } )
            };

            this.setState( state, () => {
                this.getCurrentSelection();
            } );
        }
    }

    /**
     * returns get the selected payemnt mode
     */
    getSelectedPaymentModeValue( paymentSection ) {
        log.debug( 'MemberCheckoutCostInformation.getSelectedPaymentModeValue()' );

        if( isEmpty( paymentSection ) ) {
            return 0;
        }

        const selectedMode = filter( keys( paymentSection ), mode => {
            return paymentSection[ mode ].selected;
        } );

        if( ! isEmpty( selectedMode ) ) {
            const formattedValue = this.resolvePaymentValue( paymentSection[ selectedMode ].value );
            return formattedValue;

            // return head( selectedMode );
        } else {
           return 0;
        }
    }
 
    /**
     * update prices based on shipping choice selection
     */
    UNSAFE_componentWillReceiveProps( nextProps ) {
        log.debug( 'MemberCheckoutCostInformation.UNSAFE_componentWillReceiveProps()' );

        if( ! isEqual( nextProps.shippingCharges, this.props.shippingCharges ) && ! isUndefined( this.state.componentData ) ) {

            // update shippingCharges
            let state = cloneDeep( this.state );

            // update shipping charges
            set( state, 'componentData.costCalculation.shippingCharges', nextProps.shippingCharges );

            // get the order payment amount
            const orderPaymentAmount = toNumber( get( state.componentData, 'costCalculation.shippingCharges', 0 ) ) + toNumber( get( state.componentData, 'costCalculation.rxEstimatedCost', 0 )  );

            // update toal order payment
            if( ! isEmpty( get( state, 'componentData.costSelection', {} ) ) ) {
                set( state, 'componentData.costSelection.orderPayment.payTotal.value', orderPaymentAmount );

                // set updated value on PayAch option also
                set( state, 'componentData.costSelection.orderPayment.payAch.value', orderPaymentAmount );
            }

            state = {
                ...state,
                ...this.getCostSelectionValues( { componentData: get( state, 'componentData', undefined ) } )
            };

            this.setState(  state, () => {
                this.getCurrentSelection();
            } );
        }
    }

    /**
     * called every time any selection changes shipping info or if a user selected pay other value,
     * calculates the remaining balance payment and order payment etc
     */
    getCurrentSelection() {
        log.debug( 'MemberCheckoutCostInformation.getCurrentSelection()' );
        const data = get( this.state, 'componentData', undefined );
        const chargeNowAmount = get( this.state, 'chargeNowAmount', 0 );

        if( ! isEmpty( data ) ) {

            let balancePayment = null;
            let payOtherAmount = null;
            let orderPayment = null;
            let isValid = false;
            let payLater = false;
            let payOther = false;
            let payAch = false;

            if( ! isEmpty( get( data, 'costSelection', {} ) ) ) {

                // sellected order selected mode
                balancePayment = get( data, 'costSelection.balancePayment.payTotal.value', 0 );
                payOtherAmount = get( data, 'costSelection.balancePayment.payOther.value', '0.00' );
                orderPayment = this.getSelectedPaymentModeValue( get( data, 'costSelection.orderPayment' ) );
                isValid = this.state.isRemaningBalanceValid;
                payOther = get( data, 'costSelection.balancePayment.payOther.selected', false );
                payLater = get( data, 'costSelection.orderPayment.payLater.selected', false );
                payAch = get( data, 'costSelection.orderPayment.payAch.selected', false );
                
            } else {
                balancePayment = get( data, 'costCalculation.balancePayment', 0 );
                orderPayment = this.resolvePaymentValue( get( data, 'costCalculation.rxEstimatedCost', 0 ) ) + this.resolvePaymentValue( get( data, 'costCalculation.shippingCharges', 0 ) );
                isValid = true;
            }

            const item = {
                chargeNowAmount,
                balancePayment,
                payOtherAmount,
                orderPayment,
                payOther,
                payLater,
                payAch
            };
            this.props.updateCheckoutSelection( { type: 'costSelection', item: item, isValid: isValid } );
        }
    }

    /**
     * get the correct value, if the value is null etc
     */
    resolvePaymentValue( value ) {
        if( isNil( value ) || '' === value ) {
            return 0;
        }
    
        if( isNaN( toNumber( value ) ) ) {
            return 0;
        }
    
        if( ! isNaN( toNumber( value ) ) ) {
            return toNumber( value );
        }
        return value;
    }

    /**
     * get the updated cost value based on the selection
     */
    getCostSelectionValues( { componentData } ) {
        log.debug( 'MemberCheckoutCostInformation.getCostSelectionValues()' );

        if( isUndefined( componentData ) ) {
            return;
        }

        if( isEmpty( get( componentData, 'costSelection', null ) ) ) {

            const chargeNowAmount = this.resolvePaymentValue( get( componentData, 'costCalculation.rxEstimatedCost', 0 ) ) + this.resolvePaymentValue( get( componentData, 'costCalculation.shippingCharges', 0 ) );
            
            return {
                chargeNowAmount,
                remainingAmount: 0,
                isRemaningBalanceValid: true,
            };
        }
        
        // total charge amount
        const selectedBalanceAmount = this.getSelectedPaymentModeValue( get( componentData, 'costSelection.balancePayment' ) );
        const selectedOrderPaymentAmount = this.getSelectedPaymentModeValue( get( componentData, 'costSelection.orderPayment' ) );
        const chargeNowAmount = selectedBalanceAmount + selectedOrderPaymentAmount;

        // total payable amount
        const totalOrderAmount = this.resolvePaymentValue( get( componentData.costSelection, 'orderPayment.payTotal.value', 0 ) );
        const totalBalanceAmount = this.resolvePaymentValue( get( componentData.costSelection, 'balancePayment.payTotal.value', 0 ) );
        const totalPayableAmount = totalBalanceAmount + totalOrderAmount;

        // pay other value
        const remainingAmount = totalPayableAmount - chargeNowAmount;
        const isRemaningBalanceValid = remainingAmount <= toNumber( get( componentData, 'costSelectionConfig.remainingBalance.config.maxAmount', 0 ) ) && ( -1 < remainingAmount  );
        
        return {
            chargeNowAmount,
            remainingAmount,
            isRemaningBalanceValid,
        };
    }

    /**
     * @desc: action executed when user updateds selection
     */
    handleCostSelectionUpdate( { type, item } ) {
        log.debug( 'MemberCheckoutCostInformation.handleCostSelectionUpdate()' );

        const componentData = cloneDeep( this.state.componentData );
        const updateTypeItem = get( componentData, `costSelection.${type}` );

        forEach( keys( updateTypeItem ), updateMode => {
            updateTypeItem[ updateMode ].selected = updateMode === item.name;
        } );

        if( 'balancePayment' === type && 'payTotal' === item.name ) {
            updateTypeItem.payOther.value = 0;
        }

        set( componentData, `costSelection.${type}`, updateTypeItem );

        // get the updated values
        const { chargeNowAmount, remainingAmount, isRemaningBalanceValid } = this.getCostSelectionValues( { componentData } );
        
        this.setState( {
            componentData,
            chargeNowAmount,
            remainingAmount,
            isRemaningBalanceValid
        }, () => {
            this.getCurrentSelection();
        } );
    }

    /**
     * @desc: when user updates the pay other amount value
     */
    handlePayOtherAmountUpdate( value ) {
        log.debug( 'MemberCheckoutCostInformation.handlePayOtherAmountUpdate()' );

        const componentData = cloneDeep( this.state.componentData );
        set( componentData, 'costSelection.balancePayment.payOther.value', value );

        const { chargeNowAmount, remainingAmount, isRemaningBalanceValid } = this.getCostSelectionValues( { componentData } );

        this.setState( {
            componentData,
            chargeNowAmount,
            remainingAmount,
            isRemaningBalanceValid,
        }, () => {

            this.getCurrentSelection();
        } );

    }

    /*********************************************/

    /**
     * @desc When component unmounts, cleanup resouces.
    */
    componentWillUnmount() {
        this.memberCheckoutCostInformationService.cancel(); // cancel ongoing requests
    }

    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <MemberCheckoutCostInformationView
                isFetching={ this.state.isFetching }
                networkStatus={ this.state.networkStatus }
                { ...get( this.state, 'componentData', {} ) }
                
                isRemaningBalanceValid={ this.state.isRemaningBalanceValid }
                chargeNowAmount={ this.state.chargeNowAmount }
                remainingAmount={ this.state.remainingAmount }
                requestPayload={ this.props.requestPayload }
                updateCostSelection={ this.handleCostSelectionUpdate }
                onPayOtherAmountUpdate={ this.handlePayOtherAmountUpdate }
            />
        );
    }
}

// set display name
MemberCheckoutCostInformation.displayName = 'MemberCheckoutCostInformation';

// set default props
MemberCheckoutCostInformation.defaultProps = {
    shippingCharges: null
};

// prop types
MemberCheckoutCostInformation.propTypes = {};
